export const MODEL_HUB_SCREEN = 'MODEL_HUB_SCREEN';

// Layout dimensions shared between the navbar and the main content padding. Explicit px values
// intentionally bypass Mantine's rem() conversion, which is incorrect under the monolith's
// `html { font-size: 62.5% }` (10px root).
export const MODEL_HUB_NAVBAR_WIDTH_PX = 248;
export const MODEL_HUB_MAIN_PADDING_X_PX = 40;
export const MODEL_HUB_MAIN_PADDING_Y_PX = 32;
export const MODEL_HUB_INFERENCE_BANNER_HEIGHT_PX = 52;
